import { render, staticRenderFns } from "./innerMongolia.vue?vue&type=template&id=ac36fc06&scoped=true"
import script from "./innerMongolia.vue?vue&type=script&lang=js"
export * from "./innerMongolia.vue?vue&type=script&lang=js"
import style0 from "./innerMongolia.vue?vue&type=style&index=0&id=ac36fc06&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac36fc06",
  null
  
)

export default component.exports